import "./adyen";
import { App } from "./app";

export {
    App,
};
